import { seoService } from "../../services/api";

// API returns: { shop: { title: "...", meta: "...", h1: "...", ... }, ... }
// API update:  PUT /seo/:page/:key  with body { value }

type SeoData = Record<string, Record<string, string>>;

let seoCache: SeoData = {
  shop: {
    h2_2: "Асортимент регулярно оновлюється. Кожен товар виготовляється з дотриманням встановлених стандартів та вимог.",
    meta: "Офіційний мерч 210 окремого штурмового полку — футболки, худі, прапори, нарукавні знаки, чашки, блокноти та інша продукція з офіційною символікою.\n",
    h2_1: "Усі виробники продукції проходять попередню перевірку якості. Ми приділяємо увагу матеріалам, виконанню та відповідності зображень офіційній символіці підрозділу. Це дозволяє забезпечити стабільну якість кожного виробу.",
    h1: "Магазин 210 окремого штурмового полку",
    title: "Мерч 210 окремого штурмового полку — офіційний магазин",
    description:
      "Мерч 210 ОШП — це офіційна продукція із символікою підрозділу. У каталозі представлені блокноти, одяг, нарукавні знаки, прапори, чашки, брелки та інша сувенірна продукція.\n",
  },
};

// Fetch all SEO data and populate the local cache
export async function loadSeo(): Promise<void> {
  try {
    const response = await seoService.getAll();
    if (response.data) seoCache = response.data;
  } catch (error) {
    console.error("Failed to load SEO data:", error);
    throw new Error("Не вдалося завантажити SEO дані");
  }
}

// Get all fields for a page as { key: value }
export function getSeoPage(page: string): Record<string, string> {
  return seoCache[page] ?? {};
}

// Get a single value by page + key
export function getSeoValue(page: string, key: string): string {
  return seoCache[page]?.[key] ?? "";
}

// Save all fields for a page — one PUT per key (matches the endpoint)
export async function updateSeoPage(page: string, fields: Record<string, string>): Promise<void> {
  try {
    await Promise.all(
      Object.entries(fields).map(([key, value]) => seoService.update(page, key, value)),
    );
    seoCache[page] = { ...(seoCache[page] ?? {}), ...fields };
  } catch (error) {
    console.error(`Failed to update SEO for page "${page}":`, error);
    throw new Error("Не вдалося оновити SEO дані");
  }
}
